import type { Me } from "../../shared/api";

/** Where "Scanner et démarrer" must go given the account state (Figma 03 → 04 → 04b → 05). */
export function nextStepFor(m: Me | null | undefined, vehicleId?: string): string {
  const q = vehicleId ? `?vehicle=${encodeURIComponent(vehicleId)}` : "";
  // Signed out: sign in, then resume the flow at /start (activation → payment → scan).
  if (!m) return `/signin?next=${encodeURIComponent(`/start${q}`)}`;
  if (!m.activated) return `/activate${q}`;
  // Pony account without a verified phone (CREATED / OTP_REQUIRED) can't ride or book yet.
  if (m.ponyStatus === "CREATED" || m.ponyStatus === "OTP_REQUIRED") return `/phone${q}`;
  if (!m.hasPaymentMethod) return `/payment${q}`;
  return `/scan${q}`;
}
